/**
 * O `callbackUrl` reduzido a um CAMINHO interno, ou `null`.
 *
 * Ele chega de duas formas legítimas, e as duas precisam passar:
 *
 * - **absoluta de mesma origem** — é o que o `signIn()` sem argumentos produz, porque o padrão dele
 *   é `window.location.href`. É a forma NORMAL do fluxo de convite, e uma checagem de "começa com
 *   `/`" a rejeita inteira;
 * - **relativa** — quando alguém a monta à mão, como o link de cadastro faz.
 *
 * E precisa recusar redirect aberto. Comparar prefixos não serve: `/\evil.example` passa por
 * `startsWith('/')` e não começa com `//`, mas o navegador normaliza a barra invertida como
 * separador e resolve para `https://evil.example/`. A única forma que resiste é **resolver contra a
 * origem do app e comparar a origem resultante** — é o navegador fazendo a normalização em vez de a
 * gente adivinhá-la.
 *
 * Devolve caminho + querystring + hash, nunca a URL absoluta: o destino volta para o roteador
 * interno, e passar origem para ele é convite a repetir o problema em outro lugar.
 */
export const resolveInternalCallback = (
  callbackUrl: unknown,
  origin: string,
): string | null => {
  if (typeof callbackUrl !== 'string' || !callbackUrl) return null;

  try {
    const resolvida = new URL(callbackUrl, origin);

    if (resolvida.origin !== new URL(origin).origin) return null;

    return `${resolvida.pathname}${resolvida.search}${resolvida.hash}`;
  } catch {
    return null;
  }
};
